const { createContext } = require("react");

export const AppContext = createContext(null);
